import Nullstack from 'nullstack';
export default function IconTextIncrease({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-text-increase",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 13h7"
  }), "   ", Nullstack.element("path", {
    d: "M18 9v6"
  }), "   ", Nullstack.element("path", {
    d: "M21 12h-6"
  }), " ");
}